export default "__VITE_ASSET__BqL5$I0i__"